import * as React from "react"
import { SVGProps } from "react"

const SvgDocumentCertificate = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-0.6 -0.6 14 14" {...props}>
    <desc>{"\r\n    Document Certificate Streamline Icon: https://streamlinehq.com\r\n  "}</desc>
    <g stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2}>
      <path d="M12.343 4.248V1.371a.914.914 0 0 0-.914-.914H1.37a.914.914 0 0 0-.914.914v7.315c0 .505.41.914.914.914h4.76" />
      <path d="M10.057 10.134a2.286 2.286 0 1 0 0-4.572 2.286 2.286 0 0 0 0 4.572M2.743 2.766h5.6M2.743 5.09h2.514" />
      <path d="M8.543 9.564v2.779l1.514-.629 1.514.629V9.564M10.057 8.077a.229.229 0 1 1 0-.458M10.057 8.077a.229.229 0 1 0 0-.458" />
    </g>
  </svg>
)
export default SvgDocumentCertificate
